/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */

import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '../../molecules/accordion/accordion';
import Table from '../../molecules/table/table';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import FormSelect from '../../molecules/formSelect/formSelect';
import FormCheckbox from '../../molecules/formCheckbox/formCheckbox';
import FormInputText from '../../molecules/formInputText/formInputText';
import FormExternalResource from '../../molecules/formExternalResource/formExternalResource';
import FormDatePicker from '../../molecules/formDatePicker/formDatePicker';
import FormUploadAsync from '../../molecules/formUploadAsync/formUploadAsync';
import FormLoadFromCatalog from '../../molecules/formLoadFromCatalog/formLoadFromCatalog';
import FormShowText from '../../molecules/formShowText/formShowText';
import { storeStructure } from '../../../store/reducers';
import FormValidation from '../../atoms/formEnums/formValidation';
import FormRelationship from '../formRelationship/formRelationship';
import FormTextEditor from '../../molecules/formTextEditor/formTextEditor';
import FormInputRelationship from '../formInputRelationship/formInputRelationship';
import FormMultipleUploadAsync from '../../molecules/formMultipleUploadAsync/formMultipleUploadAsync';
import TextScroll from '../../atoms/textScroll/textScroll';
import WebsocketLog from '../WebsocketLog/websocketLog';
import FormJSONComponent from '../../molecules/formJSONComponent/formJSONComponent';
import { config } from '@fortawesome/fontawesome-svg-core';
import FormStatus from '../../molecules/formStatus/formStatus';
import LogComponent from '../LogComponent/LogComponent';
import PosterMatrix from '../PosterMatrix/posterMatrix';
import FormColorPicker from '../../molecules/formColorPicker/formColorPicker';
import { LinkTheme } from '../../atoms/link/link';
import { Button } from 'react-bootstrap';
import { ButtonTheme } from '../../atoms/button/button';
import { IconType } from '../../atoms/icon/icon';
import FormPopup from '../../molecules/formPopup/formPopup';
import PopupTable from '../PopupTable/PopupTable';
import FormInputObj from '../../molecules/formInputObj/formInputObj';
import ButtonForm from '../../atoms/buttonForm/buttonForm';
import CanvasComponent from '../canvasComponent/canvasComponent';
import GridButtons from '../../molecules/gridButtons/gridButtons';
import ListTableTemplate from '../../templates/listTableTemplate/listTableTemplate';
import ListTableComponent from '../listTableComponent/listTableComponent';
import FormRelationshipFilter from '../formRelationship/formRelationshipFilter';
import FormArray from '../../molecules/formArray/formArray';
import ExternalLink from '../../atoms/externalLink/externalLink';
import FormLink from '../../molecules/formLink/formLink';
import FormCameraPresentationComponent from '../../molecules/formCameraPresentationComponent/formCameraPresentationComponent';
import ButtonPopup from '../../atoms/buttonPopup/buttonPopup';
import FormYaml from '../../molecules/formYaml/formYaml';
import FormJson from '../../molecules/formJson/formJson';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import FormTagsPreview from '../../molecules/formTagsPreview/formTagsPreview';
import FormInteractableGraphics from '../../molecules/formInteractableGraphics/formInteractableGraphics';
import ButtonSimple from '../../atoms/buttonSimple/buttonSimple';
import SpacesMap from '../spacesMap/spacesMap';
import Divider from '../../atoms/divider/divider';
import { useLocation } from 'react-router-dom';
const FormGroup = (props) => {
  const {
    name,
    value,
    match,
    configFile,
    onChange,
    onReset,
    onUpdateWithRefresh,
    onCreateWithRefresh,
    onChangeItemPosition,
    onDeleteInputRelationship,
    onUpload,
    onCompletedUploadFiles,
    onCanceledUploadFiles,
    onPopupOpenned,
    params,
    parentData,
    onEdited,
    errorResolution,
    initialValuesRef
  } = props;
  const location = useLocation();
  const [fieldValue,setFieldValue] =useState(null);
  const [defaultValues,setDefaultValues] =useState({});
  const [defaultValue,setDefaultValue] =useState(null);
  const [paramsValue,setParamsValue] =useState(null);
  const [formGroupHide,setFormGroupHide] =useState(false);
  const errorState = useSelector((state) => state[storeStructure.Errors]);
  const [valueModified,setValueModified]=useState([]);
  const [formGroupValue,setFormGroupValue]=useState(null);
  const arrLength = 100;
  const popupOpenStatus=(v,avoidPopupSockets)=>{
    if(!avoidPopupSockets){ 
      onPopupOpenned(v)
    }
  }
  useEffect(() => {
    if(value!=null){
      if(configFile.visibleWhen){
        if(value[configFile.visibleWhen.field]!=configFile.visibleWhen.value){
          setFormGroupHide(true);
        }
      }
      setFormGroupValue(value);
      getDefaultValues();
    }
  }, [value]);

  const getDefaultValues=()=>{
    if(configFile){
      if(configFile.fields && configFile.fields.length>0){
        let defaults={};
        for(let i in configFile.fields){
          if(configFile.fields[i].default){
            defaults={...defaults,[configFile.fields[i].attributeName]:configFile.fields[i].default};
          }
          
        }
        setDefaultValues(defaults);
      }
    }
      
  }
  
  const applyFieldSync = (changes, attributeName, field, currentFormValue) => {
    if (!field?.sync) return changes;

    const { targetField, mode, compareKey = 'id' } = field.sync;
    if (!targetField || mode !== 'append-if-missing') return changes;

    let sourceValue = changes[attributeName];
    if (Array.isArray(sourceValue)) {
      sourceValue = sourceValue.length > 0 ? sourceValue[0] : null;
    }

    if (!sourceValue) {
      return changes;
    }

    let currentTarget =
      changes[targetField] !== undefined
        ? changes[targetField]
        : currentFormValue?.[targetField];

    const normalizedTarget = Array.isArray(currentTarget)
      ? currentTarget.flat().filter(Boolean)
      : [];

    const alreadyExists = normalizedTarget.some(
      (item) => item?.[compareKey] === sourceValue?.[compareKey]
    );

    if (alreadyExists) return changes;

    return {
      ...changes,
      [targetField]: [...normalizedTarget, sourceValue],
    };
  };
  const handlerSearch = (values) => {
    onChange(values);
  }

  const handleUpdateComposeExperienceCameras = (values) => {
    onChange({["cameraName"]:values['cameraName']});
  }

  const handlerOnChangeJSONObject= (attributeName, id,valueJson)=>{
      onChange({ [attributeName]:valueJson});
  };
 const handlerOnChangeInteractable=(event,attributeName,allObject,field)=>{
  let changes={};
  changes={...changes,[attributeName]:event};
  onChange(changes);
 }
 const handlerOnChangeTableRow=(event,attributeName,obj,field)=>{
 }
  const handlerOnChange = (event, attributeName, allObject = false,field=null) => {
    let changes={};
    if(field && field.hasOwnProperty("onChangeUrl")){
      const data = {
        [attributeName]: event.target.value
      }
      httpPost(field.onChangeUrl,data).then((res)=>{
        onChange(res)
      }).catch(error=>{console.log("error",error)});
    }
    if(field && field.hasOwnProperty("flushChildrenOnchange")){
      changes={...changes,[field.flushChildrenOnchange]:undefined};
    }
    if (allObject) {
      if(Array.isArray(event.target.value))
        onChange(event.target.value[0]);
    } else {
      if(field && field.hasOwnProperty("fieldsToUpdate")){
        let relatedFieldsToUpdate=field["fieldsToUpdate"];
        relatedFieldsToUpdate.forEach((el)=>{
          if(el=="composeExperienceLink"){
            let url="/assetsmanager/composeexperience/edit/";
            changes={...changes,[el]:url+event.target.value["composeExperienceId"]};   
          }else if(el=="liveLink"){
            let url="/assetsmanager/lives?id=";
            changes={...changes,[el]:url+event.target.value["live_id"]};   
          }else
            changes={...changes,[el]:event.target.value[el]};  
        });
        changes={...changes,[attributeName]:event.target.type === 'checkbox' ? event.target.checked : event.target.value};
        changes = applyFieldSync(changes, attributeName, field, value);
        onChange(changes);
      }else{
        changes={...changes,[attributeName]:event.target.type === 'checkbox' ? event.target.checked : event.target.value};
        if (field && field.onChangeSetField && event.target.option) {
          const { target, fromOptionField } = field.onChangeSetField;
          if(event.target.option['value'] !== '(Empty)')
            changes[target] = event.target.option[fromOptionField];
        }
        changes = applyFieldSync(changes, attributeName, field, value);
        onChange(changes);
      }
    }
  };
  const handlerChangeAndRefresh=(data)=>{
    onChange(data);
  }
  const handlerEditedForm=(value)=>{
      onEdited(value);
  }
  const handlerUpdateAll=(values)=>{
    // onChange(values); //fix for lives removed because on canvas failed when publishing
    onUpdateWithRefresh(values);
    onEdited(false);
    setFormGroupValue(null);
  }
  const handlerFormButton = (newDataObject, attributeName) => {
    onChange({ [attributeName]: newDataObject.id });
  };

  const handlerOnTableCreate = (newRow, attributeName) => {
    const field = configFile.fields.find((x) => x.attributeName === attributeName);
    const newTableRow = field.configFile.fields
      .reduce((acumulator, x) => ({ ...acumulator, [x.attributeName]: x.default }), {});
    const newTableValue = value[attributeName] ? [...value[attributeName], { ...newTableRow, ...newRow }] : [{ ...newTableRow, ...newRow }];
    if (configFile.refreshUpdate) onCreateWithRefresh({ [attributeName]: newTableValue });
    else handlerOnChange({ target: { value: newTableValue } }, attributeName);
  };

  const handlerOnTableDelete = (deleteRow, attributeName) => {
    const formFieldValues = value[attributeName];
    const indexOfDeleteRow = formFieldValues.indexOf(deleteRow);
    formFieldValues.splice(indexOfDeleteRow, 1);
    
    handlerOnChange({ target: { value: formFieldValues } }, attributeName);
  };

  const handlerOnInputRelationshipTableDelete = (deleteRow, attributeName) => {
    
    onDeleteInputRelationship(deleteRow, attributeName);
  };
  const findFromValues=(uniqueId,fieldRelated,params)=>{
    var promise = new Promise( (resolve, reject) => {
    if(uniqueId){
      findItems(uniqueId,params[fieldRelated.node]).then((found)=>{
        if(found){
          resolve({"fieldRelated":fieldRelated,"value":found.type});
        }else{
          return "";
        }
      });
    }
  });
  return promise;
  }

  const findItems=(uniqueId,params,func)=>{
    var promise = new Promise( (resolve, reject) => {
      params.forEach((children)=>{
        if(children.uniqueId==uniqueId){
          resolve(children);
        }else if(children["ingestProcesses"] || children["streams"]){
            if(children["ingestProcesses"])
              findItems(uniqueId,children["ingestProcesses"]);
            else if(children["streams"])
              findItems(uniqueId,children["streams"]);
        }else{
          reject("");
        }
      });
    });
    return promise;
  }
  const extractValueRelated=(value,field,params=null,p1)=>{
    var promise = new Promise( (resolve, reject) => {
      let fieldsRelated=field[p1];
      let promises=[];
      fieldsRelated.forEach((fieldRelated)=>{
        let fValue;
        if(fieldRelated){
          if(fieldRelated.from){
            if(fieldRelated.from=="parentData"){
              if(fieldRelated.mode=="cont"){
                let cont=0;
                if(parentData){
                  parentData.forEach((el)=>{
                    if(el[fieldRelated.field]==value[fieldRelated.field]){
                        cont+=1;
                    }
                  });
                }
                promises.push({"fieldRelated":fieldRelated,"value":["_","concat","right",cont]});
              }
            }
          }else{
            promises.push({"fieldRelated":fieldRelated,"value":value[fieldRelated.field]});
          }
        }
      });
      Promise.all(promises).then(function(resultsArray){
        let ret="";
        resultsArray.forEach((elem)=>{
          ret=processValue(elem.fieldRelated,elem.value,ret);
        });
        resolve(ret);
        // do something after the loop finishes
      }).catch(function(err){
        reject("error");
        // do something when any of the promises in array are rejected
      })
    });
    return promise;
  }
  const handleGridButtonOnNewContent=(option)=>{
    onChange(option);
  }

  const processValue=(fieldRelated,fValue,ret)=>{
    switch(fieldRelated.value[1]){
      case "concat":
        if(!fieldRelated.value[3] ||(fieldRelated.value[3]==">1")){
          if(fieldRelated.value[2]=="left"){
            ret+= fieldRelated.value[0] + fValue;
          }else if(fieldRelated.from=="parentData"){
            if(fValue[3]!=0){
              ret+=fieldRelated.value[0]+ parseInt(fValue[3]+1);
            }
          }else{
            ret+=fieldRelated.value[0]+ fValue;
          }
        }
      
      break;
      case "obj":
        ret+="#"+fieldRelated.value[2]+"_"+fValue;
    }
    return ret;
  }

  return (
    <>
    {!formGroupHide && <Accordion id={configFile.attributeName} title={configFile.title} helpText={configFile.helpText} className={configFile.cssClass}>
      <div className="row" style={{"overflow-x":"auto"}}>
      {configFile.fields.map((field, i) => {
        let out;
        if(field.visibleWhenCreate==false){
          if(location.pathname.slice(-3)=="new"){
            return null;
          }
        }
        if(field.visibleWhenEdit==false){
          if(location.pathname.slice(-3)!="new"){
            return null;
          }
        }
        if(field.visibleWhen){   
            if(Array.isArray(field.visibleWhen)){
              let arrVisible=true;
              let hasOr = field.visibleWhen.some(r => r.or);
              if (hasOr && formGroupValue) {
              const orVisible = field.visibleWhen.some((elArr) => {
                if (elArr.value == "bool-false") {
                  return formGroupValue[elArr.field] !== true;
                }

                if (elArr.value == "not-null") {
                  return !(
                    formGroupValue[elArr.field] == 0 ||
                    formGroupValue[elArr.field] == "" ||
                    formGroupValue[elArr.field] == undefined
                  );
                }

                if (elArr.notValue !== undefined) {
                  return !(
                    formGroupValue[elArr.field] == undefined ||
                    formGroupValue[elArr.field] == elArr.notValue
                  );
                }
                return (
                  formGroupValue[elArr.field] == elArr.value
                );
              });

              if (!orVisible) arrVisible = false;
            } else {
              field.visibleWhen.forEach((elArr)=>{
                if(formGroupValue && elArr.value=="bool-false"){
                  if(formGroupValue[elArr.field]==true){
                    arrVisible=false;
                  }
                }else if(formGroupValue && elArr.value && elArr.value!="bool-false" && elArr.value && elArr.value!="not-null" && (formGroupValue[elArr.field]===undefined || formGroupValue[elArr.field]!=elArr.value)){
                  arrVisible=false;
                }else if(formGroupValue && elArr.value=="not-null"){
                  if(formGroupValue[elArr.field]==0 || formGroupValue[elArr.field]=="" || formGroupValue[elArr.field]==undefined){
                    arrVisible=false;
                  }
                }else if(formGroupValue && elArr.notValue){
                  if((formGroupValue[elArr.field]==undefined && !elArr.allowUndefined)  || formGroupValue[elArr.field]==elArr.notValue){
                    arrVisible=false;
                  }
                }
              });
            }
              if(arrVisible==false)
                return null;
            }else{
              if(typeof(field.visibleWhen.value=="boolean") && formGroupValue && formGroupValue[field.visibleWhen.field]==undefined)
                formGroupValue[field.visibleWhen.field]=false;
              
              if (formGroupValue) {
                const currentValue = formGroupValue[field.visibleWhen.field];
                const expectedValue = field.visibleWhen?.value;
                if (Array.isArray(expectedValue)) {
                  if (!expectedValue.includes(currentValue)) {
                    return null;
                  }
                } else if (currentValue != expectedValue) {
                  return null;
                }
              }
            }
        }
        if(field.disableWhen){
          if(Array.isArray(field.disableWhen?.value)){
            if(formGroupValue && field.disableWhen.value.includes(formGroupValue[field.disableWhen.field]))
              return null;
          }else{
            if(formGroupValue && formGroupValue[field.disableWhen.field]==field.disableWhen.value)
              return null;
          }
         }
        const isMissing = (v) => v === undefined || v === null || v === '';
        const evalSimpleRule = (rule) => {
          const v = value?.[rule.field];
          if (rule.notValues) return !rule.notValues.includes(v);
          if (Array.isArray(rule.values)) return rule.values.includes(v);
          if (rule.values === 'not-null') return !isMissing(v);
          if (rule.values === 'missing') return isMissing(v);

          return v === rule.values;
        };

        const evalRule = (rule) => {
          if (rule && rule.rules && Array.isArray(rule.rules)) {
            const op = rule.op || 'and';
            return op === 'or'
              ? rule.rules.some(evalRule)
              : rule.rules.every(evalRule);
          }
          return evalSimpleRule(rule);
        };
        if (field.enabledWhen) {
          if (field.enabledWhen.rules && Array.isArray(field.enabledWhen.rules)) {
            const op = field.enabledWhen.op || 'and';
            const enabled =
              op === 'or'
                ? field.enabledWhen.rules.some(evalRule)
                : field.enabledWhen.rules.every(evalRule);

            field.disabled = !enabled;
          } else {
            let f = field.enabledWhen.field;
            let values = field.enabledWhen.values;
            if (values) {
              if (value[f] == undefined && defaultValues[f]) {
                if (values.includes(defaultValues[f]))
                  field.disabled = false;
                else
                  field.disabled = true;
              } else {
                if (values?.includes(value[f]))
                  field.disabled = false;
                else {
                  if (values == "not-null" && value[f] == undefined) {
                    field.disabled = false;

                  }
                  else {
                    field.disabled = true;
                  }
                }
              }
            }
            let notValues = field.enabledWhen.notValues;
            if (notValues) {
              if (notValues.includes(value[f]))
                field.disabled = true;
              else
                field.disabled = false;
            }
          }
        }
        if(field.disabledWhenEdit){
           let location=window.location.pathname;
          let locationArr = location.split("/");
          let lastId=locationArr[locationArr.length-2];
          let live =locationArr[locationArr.length-3];
          if(params=="edit" || (live!="lives" && lastId=="edit")){
            field.disabled=true;
          }else
            field.disabled=false;
        }
        if(field.disabledWhenNew){
          let location=window.location.pathname;
          let locationArr = location.split("/");
          let lastId=locationArr[locationArr.length-1];
          if(params==undefined){
            if(lastId=="new")
              field.disabled=true;
            else
              field.disabled=false;
          }else if(params!="edit"){
            field.disabled=true;
          }else{
            field.disabled=false;
          }
        }
        if(field.valueWhen && (formGroupValue && (formGroupValue[field.attributeName]==undefined))){
          if(params!="edit"){
            extractValueRelated(formGroupValue,field,params,"valueWhen").then((val)=> {
              setFormGroupValue({...formGroupValue,[field.attributeName]:val});
              value[field.attributeName]=val;
              // setFormGroupValue({...formGroupValue,[field.attributeName]:val})
              // setFieldValue(null);
              setDefaultValue(val);
            });
          }
        }
        if(field.parentObject){
          if(formGroupValue && formGroupValue[field.parentObject] && formGroupValue[field.parentObject]["updated"]){
            field.refreshData=formGroupValue[field.parentObject][field.parentField];
          }
        }
        if(field.paramWhen && formGroupValue){
            extractValueRelated(formGroupValue,field,params,"paramWhen").then((val)=> {
              let params={};
              let field=val.split("#");
              if(field!=""){
                field.forEach((f)=>{
                  let fieldDetail=f.split("_");
                  if(fieldDetail[0]!=""){
                    params={...params,...{[fieldDetail[0]]:fieldDetail[1]}};
                  }
                });
              }
              setParamsValue(JSON.stringify(params));
            });
            
        }
        if(field.parentField){
          if(field.parentField && (value[field.parentField]!="(Empty)" || field?.ignoreEmptyValue)){
            field.refreshData=value[field.parentField];
          }
        }
        switch (field.type) {
          case FormInputTypes.TABLECOMPONENT:
            out=(
             <ListTableComponent
                key={field.attributeName + i}
                configFile={field.configFile}
                tableName={field.attributeName}
                mode={field.mode}
                onAfterEdit={field.onAfterEdit ?? null}
                parentValue={formGroupValue}
                setParentValue={setFormGroupValue}
                initialValuesRef={initialValuesRef}
                onChange={(event) => handlerOnChange({ target: { value: event } }, field.attributeName)}
                onChangeAndRefresh={handlerChangeAndRefresh}
                // value={(value && value[field.attributeName]) ? value[field.attributeName] : (field.default?field.default:'')}
                value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:(defaultValues[field.attributeName]?defaultValues[field.attributeName]:''))}
                match={match}
              />
            );
            break;
          case FormInputTypes.TABLE2:
            out=(
              <ListTableTemplate
                configFile={field.configFile}
                onChange={(event) => handlerOnChange({ target: { value: event } }, field.attributeName)}
                onChangeRow={(event) => handlerOnChangeTableRow({ target: { value: event } }, field.attributeName)}
                selValue={value}
                // selValue={formGroupValue}
              />
            );
            break;
          case FormInputTypes.TABLE:
            out = (
              <Table
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                dataSet={value[field.attributeName] === undefined || value[field.attributeName] ==''? [] : value[field.attributeName]}
                // dataSet={formGroupValue[field.attributeName] === undefined ? [] : formGroupValue[field.attributeName]}
                columnSet={field.configFile.fields}
                label={field.label}
                rowHighlight={field.configFile.rowHighlight}
                collapsable={field.configFile.collapsable}
                canEdit={field.configFile.canEdit}
                configFile={field.configFile}
                canRemove={field.configFile.canRemove}
                onChangeDataSet={handlerSearch}
                canCreateWhen={field.configFile.canCreateWhen}
                removeMessage={field.configFile.removeMessage}
                onChange={(event) => handlerOnChange({ target: { value: event } }, field.attributeName)}
                canOpen={field.configFile.canOpen}
                canCreate={field.configFile.canCreate}
                onClickEdit={field.configFile.handleClickEdit}
                onClickCreate={(event) => handlerOnTableCreate(event, field.attributeName)}
                onClickRemove={(event) => handlerOnTableDelete(event, field.attributeName)}
                onClickRemoveInputRelationship={(event) => handlerOnInputRelationshipTableDelete(event, field.attributeName)}
                emptyMessage={field.configFile.emptyMessage}
                isSelectable={field.configFile.isSelectable}
                isMultiSelectable={field.configFile.isMultiSelectable}
                canChangePosition={field.configFile.canChangePosition}
                sortingPositionIndex={field.configFile.sortingPositionIndex}
                onChangePosition={onChangeItemPosition}
                />
            );
          break;
          case FormInputTypes.POPUPTABLE:
              out = (
                <PopupTable 
                  field={field}
                  newButton={field.newButton}
                  secondaryButtonText={field.secondaryButtonText} 
                  configFile={configFile}
                  disabledOnNew={field.disabledOnNew} 
                  i={i} 
                  key={field.attributeName + i}
                  value={value}
                  // value={formGroupValue}
                  onChangeAndRefresh={handlerChangeAndRefresh}
                  />

              );
            break;  
          case FormInputTypes.SELECT:
            out = (
              <FormSelect
                id={(configFile.attributeName?configFile.attributeName+"-":"")+field.attributeName}
                key={field.attributeName + i}
                label={field.label}
                // value={(value && value[field.attributeName]) ? value[field.attributeName] : ''}
                value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:'')}
                emptyValue={field.emptyValue}
                allValue={field.allValue}
                asyncSelect={field.asyncSelect}
                editUrl={field.editUrl}
                placeholder={field.placeholder}
                parentField={(field.parentField?field.parentField:null)}
                refreshData={(field.refreshData?field.refreshData:null)}
                url={field.url}
                validateUrl={field.validateUrl}
                
                filter={field.filter}
                helpText={field.helpText}
                options={field.options}
                multiple={field.multiple}
                fieldValue={field.fieldValue}
                fieldCode={field.fieldCode ?? ''}
                fieldName={field.fieldName}
                fieldDisabled={field.fieldDisabled}
                fieldLabelKey={field.fieldLabelKey ?? ''}
                fieldDisabledReason={field.fieldDisabledReason}
                pageId={field.pageId}
                onChange={(event) => handlerOnChange(event, field.attributeName,false,field)}
                disabled={(field.disabled?field.disabled:false)}
                writable={(field.writable?field.writable:false)}
                loadInitialWithoutParent={(field.loadInitialWithoutParent?field.loadInitialWithoutParent:false)}
                noOptionsMessageText={(field.noOptionsMessageText?field.noOptionsMessageText:null)}
                customStyles ={(field.customStyles?field.customStyles:null)}
                ignoreEmptyValue={(field.ignoreEmptyValue?field.ignoreEmptyValue:false)}
                urlByField={field?.urlByField ? field.urlByField : null}
                />
            );
            break;
          case FormInputTypes.COLOR_PICKER:
            out = (
              <FormColorPicker
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                name={field.attributeName}
                label={field.label}
                // value={value ? value[field.attributeName] : field.default}
                value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:defaultValues[field.attributeName])}
                alphaAllow={field.alphaAllow?field.alphaAllow:false}
                onChange={(data) => handlerOnChange(data, field.attributeName)}
                helpText={field.helpText}
                isGradient={field.isGradient}
                disabled={(field.disabled?field.disabled:false)}
              />
            );
            break;
          case FormInputTypes.CHECKBOX:
            out = (
              <FormCheckbox
                key={field.attributeName + i}
                label={field.label}
                id={(configFile.attributeName?configFile.attributeName+"-":"")+field.attributeName}
                helpText={field.helpText}
                checked={(formGroupValue!=null && formGroupValue[field.attributeName]!=null?formGroupValue[field.attributeName]:null)}
                defaultValue={field.default?field.default:false}
                onChange={(event) => handlerOnChange(event, field.attributeName)}
                disabled={(field.disabled?field.disabled:false)}
                confirmPopup={(field.confirmPopup?field.confirmPopup:false)}
                confirmText={(field.confirmText?field.confirmText:"")}
              />
            );
            break;
          case FormInputTypes.DOWNLOADABLE:
          case FormInputTypes.BACKGROUND:
            out = (
              <>
              <FormExternalResource
                id={`${configFile.attributeName?configFile.attributeName+"-":""}${field.attributeName}`}
                type={field.type}
                key={field.attributeName + i}
                label={field.label}
                helpText={field.helpText}
                errorResolution={field.errorResolution}
                fileType={field.fileType}
                hasSelect={field.hasSelect}
                value={value ? value[field.attributeName] : ''}
                // value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:'')}
                onChange={(data) => handlerFormButton(data, field.attributeName)}
                aspectRatio={field.aspectRatio}
                allowedSizes={field.allowedSizes}
                imageWidth={field.imageWidth}
                imageHeight={field.imageHeight}
                canUpload={field.canUpload}
                canUpdate={field.canUpdate}
                canDelete={field.canDelete}
                size={field.size}
                disabled={field.disabled}
              /></>
            );
            break;
          case FormInputTypes.UPLOAD_ASYNC:
            out = (
              <FormUploadAsync
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                label={field.label}
                helpText={field.helpText}
                fileType={field.fileType}
                value={value ? value[field.attributeName] : ''}
                // value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:'')}

                onUpload={(data) => handlerOnChange(data, field.attributeName)}
                onCompleted={(data) => handlerOnChange(data, field.attributeName)}
              />
            );
            break;
          case FormInputTypes.MULTIPLE_UPLOAD_ASYNC:
            out = (
              <FormMultipleUploadAsync
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                label={field.label}
                storageProvider={field.storageProvider}
                helpText={field.helpText}
                fileType={field.fileType}
                defaultInputValue={field.defaultInputValue}
                value={value ? value[field.attributeName] : []}
                // value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:[])}

                onChange={(data) => handlerOnChange(data, field.attributeName)}
                onUpload={onUpload}
                onCompleted={onCompletedUploadFiles}
                onCanceled={onCanceledUploadFiles}
              />
            );
            break;
          
          case FormInputTypes.DATE:
          case FormInputTypes.DATE_TIME:

            out = (
              <FormDatePicker
                id={(configFile.attributeName?configFile.attributeName+"-":"")+field.attributeName}
                key={field.attributeName + i}
                label={field.label}
                // value={value[field.attributeName] ? value[field.attributeName] : field.default}
                value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:defaultValues[field.default])}

                onChange={(data) => handlerOnChange(data, field.attributeName)}
                helpText={field.helpText}
              />
            );
            break;
          case FormInputTypes.OTHER_RESOURCE:
            out = (
              <FormLoadFromCatalog
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                label={field.label}
                configFile={field.fromCatalog}
                helpText={field.helpText}
                onClose={(data) => handlerOnChange(data, field.attributeName, true)}
              />
            );
            break;
          case FormInputTypes.BUTTON:
            out = (
              <>
              <ButtonSimple
              id={`${configFile.attributeName}-${field.attributeName}`}
              label={field.label}
              buttonText={field.buttonText}
              handler={field.handler}
              helpText={field.helpText}
              value={formGroupValue}
              onUpdate={(values)=>handlerChangeAndRefresh(values)}
              disabled={(field.disabled?field.disabled:false)}
              />
              </>
            );
            break;
          case FormInputTypes.BUTTON_FORM:
            out = (
              <>
              <ButtonForm
              id={`${configFile.attributeName}-${field.attributeName}`}
              text={field.label}
              mode={field.mode}
              iconSize={field.iconSize}
              actionUrl={field.actionUrl}
              actionParams={field.actionParams}
              actionIsDownload={field.actionIsDownload}
              iconColor={field.iconColor}
              title={field.title}
              description={field.description}
              // value={value}
              value={formGroupValue}

              confirm={field.confirm}
              formConfig={field.formConfig}
              onUpdateForm={(values)=> field.reset ? onReset() : handlerChangeAndRefresh(values)}
            />  </>            );
            break; 
          case FormInputTypes.BUTTON_POPUP:
            out =(<ButtonPopup
                  id={`${configFile.attributeName}-${field.attributeName}`}
                  icon={field.icon}
                  buttonText={field.buttonText}
                  iconSize={field.iconSize}
                  redirectUrl={field.redirectUrl}
                  actionUrl={field.actionUrl}
                  refreshIfOk={field.refreshIfOk}
                  openUrl={field.openUrl}
                  iconColor={field.iconColor}
                  formConfig={field.formConfig}
                  // value={value}
                  value={formGroupValue}
                  onUpdateValues={(values)=>handlerUpdateAll(values)}
                  isEditId={field.isEditId}
                  sessionParams={field.sessionParams}
                  
                />);
          break;
          case FormInputTypes.TEXT:
            out = (
              <FormShowText
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                label={field.label}
                helpText={field.helpText}
                // value={value ? value[field.attributeName] : ''}
                value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:''}
                hidden={field.hidden}
              />
            );
            break;
          case FormInputTypes.STATIC_TEXT:
              out = (
                <FormShowText
                  id={`${configFile.attributeName}-${field.attributeName}`}
                  key={field.attributeName + i}
                  label={field.label}
                  helpText={field.helpText}
                  // value={value ? value[field.attributeName] : ''}
                  value={field.default}
                  hidden={field.hidden}
                  classCss={field.classCss?field.classCss:''}
                  classCssLabel={field.classCssLabel?field.classCssLabel:''}
                />
              );
              break;
          case FormInputTypes.SPACES_MAP:
              out = (
                <SpacesMap value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:[]}/>
              );
          break;
          case FormInputTypes.TEXT_SCROLL:
            out = (
              <TextScroll
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                label={field.label}
                helpText={field.helpText}
                // value={value ? value[field.attributeName] : ''}
                value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:''}
              />
            );
            break;
          case FormInputTypes.RELATIONSHIP:
            out = (
              <FormRelationship
                id={`${configFile.attributeName}-${field.attributeName}`}
                isForm
                key={field.attributeName + i}
                label={field.label}
                helpText={field.helpText}
                configFile={field.configFile}
                value={value[field.attributeName]}
                // value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:null}
                customParams={paramsValue}
                maxElements={field.maxElements}
                onSelectUrl={field.onSelectUrl}
                disabled={(field.disabled?field.disabled:false)}
                onChange={(data) => handlerOnChange(data, field.attributeName)}
              />
            );
            break;
          case FormInputTypes.RELATIONSHIPFILTER:
            out = (
                <FormRelationshipFilter
                  id={`${configFile.attributeName}-${field.attributeName}`}
                  isForm
                  key={field.attributeName + i}
                  label={field.label}
                  helpText={field.helpText}
                  configFile={field.configFile}
                  blockItemRemove={field.blockItemRemove}
                  value={value[field.attributeName]}
                  popupSize={field.popupSize??null}
                  // value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:null}
                  customParams={paramsValue}
                  customId={field.customFieldId}
                  maxElements={field.maxElements}
                  onSelectUrl={field.onSelectUrl}
                  disabled={(field.disabled?field.disabled:false)}
                  onChange={(data) => handlerOnChange(data, field.attributeName, false, field)}
                  dataRow={formGroupValue}
              />
            );
            break;
          case FormInputTypes.TEXT_EDITOR:
            out = (
              <FormTextEditor
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                toolbar={field.toolbar}
                name={field.label}
                label={field.label}
                // value={value ? value[field.attributeName] : ''}
                value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:null}
                helpText={field.helpText}
                validation={errorState[field.attributeName] === undefined
                  ? FormValidation.PENDING : FormValidation.ERROR}
                onChange={(data) => handlerOnChange(data, field.attributeName)}
              />
            );
            break;
          case FormInputTypes.TEXT_OR_RELATIONSHIP:
            out = (
              <FormInputRelationship
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                name={field.label}
                label={field.label}
                blockInput={field.blockInput}
                // value={value ? value[field.attributeName] : ''}
                value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:''}
                helpText={field.helpText}
                validation={errorState[field.attributeName] === undefined
                  ? FormValidation.PENDING : FormValidation.ERROR}
                onChange={(data) => handlerOnChange(data, field.attributeName)}
              />
            );
            break;
          case FormInputTypes.LOG:
              out = (
                // <>
                // {value && <div>{JSON.stringify(value["log_link"])}</div>}
                // {formGroupValue && <div>{formGroupValue["log_link"]!=null ?formGroupValue["log_link"]:"nooo"}</div>}
                // </>
                <>
                {formGroupValue && formGroupValue["id"] && <LogComponent
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                title=""
                // initialValues={value ? value[field.attributeName] : {}}
                initialValues={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:{}}
                legend={field.legend?field.legend:[]}
                hasFilterText={field.hasFilterText}
                filters={field.filters}
                // counters={(value && field.hasCounters && value[field.hasCounters]?value[field.hasCounters]:"")}
                counters={formGroupValue && field.hasCounters && formGroupValue[field.hasCounters] ?formGroupValue[field.hasCounters]:''}
                textNoResults={field.textNoResults}
                clearVisible={field.clearVisible}
                clearUrl={field.clearUrl}
                downloadLogs={field.downloadLogs}
                downloadLogUrl={field.downloadUrl}
                generateLogUrl={field.generateLogUrl}
                // log_link={value? value["log_link"]:{}}
                hasRealTime={field.hasRealTime?field.hasRealTime:false}
                dataId={formGroupValue?formGroupValue["id"]:null}
                logData={field.logData}
                logDataValues={formGroupValue?formGroupValue[field.logData.logDataValues]:null}
                log_link={formGroupValue?formGroupValue["log_link"]:null}
                log_total={formGroupValue?formGroupValue["log_total"]:123}
                log_pageSize={formGroupValue?formGroupValue["log_pageSize"]:5}
                log_pages={formGroupValue?formGroupValue["log_pages"]:1}
                log_current_page={formGroupValue?formGroupValue["log_current_page"]:1}
              />}</>
              );
              break;
          case FormInputTypes.WEBSOCKET_LOG:
            out = (
              <WebsocketLog
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                title=""
                eventChanel={field.websocketChannel}
                sessionParams={field.websocketSessionParams}
                // initialValues={value ? value[field.attributeName] : ''}
                initialValues={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : ''}
                
              />
            );
            break;
          case FormInputTypes.JSON_COMPONENT:
              const extraValues = {};
              if(field.extraValues && field.extraValues.length > 0){
               field.extraValues.forEach((extraValue) => {
                if(value[extraValue]){
                  extraValues[extraValue] = value[extraValue];
                }
               });
              }
              
              out = (
                <FormJSONComponent
                  id={`${configFile.attributeName}-${field.attributeName}`}
                  key={field.attributeName + i}
                  canRemove={field.canRemove}
                  canCreate={field.canCreate}
                  canEdit={field.canEdit}
                  configFile={field}
                  label={field.label}
                  // value={value ? value[field.attributeName] : null}
                  value={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : null}
                  onChangeJsonObject={handlerOnChangeJSONObject}
                  returnedPopupValues={field.returnedPopupValues}
                  helpText={field.helpText}
                  params={params}
                  onPopupOpenned={(e)=>{popupOpenStatus(e,field.avoidPopupSockets?field.avoidPopupSockets:false)}}
                  extraValues={(extraValues != {} ? extraValues:null)}
                  classCss={field.classCss?field.classCss:''}
                />
              );
            break;
          case FormInputTypes.STATUS:
              out=(
                    <FormStatus
                      key={field.attributeName + i}
                      label={field.label}
                      id={`${configFile.attributeName}-${field.attributeName}`}
                      value={value ? value[field.attributeName] : null}
                      // info={value? value[field.secondaryValue]:null}
                      info={formGroupValue && formGroupValue[field.secondaryValue]? formGroupValue[field.secondaryValue] : null}
                      colors={field.colors}
                      tooltipPosition={(field.tooltipPosition?field.tooltipPosition:null)}
                      button={field.button?field.button:null}
                    />
              );
            break;
          case FormInputTypes.TEXT_INPUT.URLPREVIEW:
                out=(
                      <div> <FormInputText
                      id={`${configFile.attributeName}-${field.attributeName}`}
                      key={field.attributeName + i}
                      name={field.label}
                      placeholder={field.placeholder}
                      helpText={field.helpText}
                      type={field.type}
                      // value={value ? value[field.attributeName] : ''}
                      value={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : ''}
                      label={field.label}
                      onChange={(event) => handlerOnChange(event, field.attributeName)}
                      errorText={errorState[field.attributeName] === undefined
                        ? '' : errorState[field.attributeName][0]}
                      defaultValue={field.default === undefined ? '' : field.default}
                      hidden={field.hidden}
                    // /><img style={{maxWidth:'100px'}} src={value ? value[field.attributeName] : ''}/></div>
                    /><img style={{maxWidth:'100px'}} src={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : ''}/></div>
                );
            break;
          
          case FormInputTypes.POSTER_MATRIX: // to be deprecated
            out = (
              <PosterMatrix
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                title=""
                // value={value ? value[field.attributeName] : ''}
                value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:''}

                configFile={field.configFile}
                // initialValues={value ? value[field.attributeName] : ''}
                initialValues={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:''}
                onChange={(event) => handlerOnChange({ target: { value: event } }, field.attributeName)}
              />
            );
          break;
          case FormInputTypes.CANVAS:
            out =(
              <CanvasComponent values={formGroupValue?formGroupValue:{}}  onPublish={(values)=>handlerUpdateAll(values)} onEdited={handlerEditedForm} />
            );
          break;
          case FormInputTypes.SEPARATOR:
              // out=(<hr />);
              out=(<><Divider text={field.text}/></>)
            break;
          case FormInputTypes.TEXT_INPUT.OBJECT:
              out = (
                <FormInputObj
                  id={`${configFile.attributeName}-${field.attributeName}`}
                  key={field.attributeName + i}
                  name={field.label}
                  placeholder={field.placeholder}
                  helpText={field.helpText}
                  type={"text"}
                  childFields={field.childFields}
                  mainField={field.mainField}
                  // value={value ? value[field.attributeName] : ''}
                  // value={(fieldValue?fieldValue[field.attributeName]:(formGroupValue[field.attributeName]!= undefined?formGroupValue[field.attributeName]:''))}
                  value={formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:''}

                  label={field.label}
                  configFile={field.fromCatalog}
                  relatedConfigTable={field.fromConfigTable}
                  onChange={(event) => handlerOnChange(event, field.attributeName,false,field)}
                  errorText={errorState[field.attributeName] === undefined
                    ? '' : errorState[field.attributeName][0]}
                  defaultValue={field.default === undefined ? '' : field.default}
                  disabled={(field.disabled?field.disabled:false)}
                  returnValue={(field.returnValue?field.returnValue:null)}
                  inputEnabled={(field.inputEnabled?field.inputEnabled:false)}
                  selectedValue={value}
                  popupSize={field.popupSize?field.popupSize:null}
                />
              );
            break;
          case FormInputTypes.GRID_BUTTONS:
            out = (
              <GridButtons onNewContent={handleGridButtonOnNewContent} value={value}/>
            );
            break;
          case FormInputTypes.ARRAY:
            out=(
              <FormArray
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                name={field.label}
                placeholder={field.placeholder}
                helpText={field.helpText}
                fields={field.fields}
                // value={value[field.attributeName]}
                value={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : []}
                label={field.label}
              />
            );
            break;
          case FormInputTypes.LINK:
            out=(
              <FormLink
                label={field.label} 
                id={`${configFile.attributeName}-${field.attributeName}`}
                icon={field.icon}
                // value={value[field.secondaryValue]}
                value={formGroupValue && formGroupValue[field.secondaryValue]? formGroupValue[field.secondaryValue] : null}
                customIcon={field.customIconObj}
                // to={value[field.attributeName]}
                to={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : null}
                iconSize={field.iconSize}
                target={field.target}
                textNoLink={field.textNoLink}
                iconColor={field.iconColor}
                postUrl={field.postUrl}
                swalTitle={field.swalTitle}
                swalText={field.swalText}
                helpText={field.helpText}
                hasClick={field.hasClick==false?false:true}
              />
            );

            break;
          case FormInputTypes.CAMERAS_PRESENTATION:
            out=(              
              <FormCameraPresentationComponent 
                value={value ? value[field.attributeName] : null}
                visibleWhen={field.visibleWhen}
                // value={formGroupValue && formGroupValue[field.attributeName]? formGroupValue[field.attributeName] : null}
                
                stepData={value} onUpdate={(event)=>handlerOnChange(event, field.attributeName)}
                onUpdateCameras={handleUpdateComposeExperienceCameras}
              />
              
            );
            break;
          case FormInputTypes.YAML:
            out=(
              <FormYaml
                label={field.label} 
                id={`${configFile.attributeName}-${field.attributeName}`}
                // value={(fieldValue?fieldValue[field.attributeName]:(value[field.attributeName]!= undefined?value[field.attributeName]:field.default === undefined ? '' : field.default))}
                value={(formGroupValue?formGroupValue[field.attributeName]:null)}
                helpText={field.helpText}
              />
            );
            break;
          case FormInputTypes.JSON:
            out=(
              <FormJson
                label={field.label} 
                id={`${configFile.attributeName}-${field.attributeName}`}
                // value={(fieldValue?fieldValue[field.attributeName]:(value[field.attributeName]!= undefined?value[field.attributeName]:field.default === undefined ? '' : field.default))}
                value={(formGroupValue?formGroupValue[field.attributeName]:null)}
                helpText={field.helpText}
              />
            );
            break;
          case FormInputTypes.INTERACTABLEGRAPHICSELECTOR:
              out=(
                <FormInteractableGraphics
                  id={`${configFile.attributeName}-${field.attributeName}`}
                  key={field.attributeName + i}
                  name={field.label}
                  placeholder={field.placeholder}
                  helpText={field.helpText}
                  place={field.place}
                  onUpdateInteractable={(event) => handlerOnChangeInteractable(event, field.attributeName)}
                  value={(formGroupValue?formGroupValue[field.attributeName]:null)}
                />
              );
            break;
          case FormInputTypes.TAGS_PREVIEW:
            out=(
              <FormTagsPreview 
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                name={field.label}
                label={field.label}
                helpText={field.helpText}
                value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:defaultValues[field.attributeName]?defaultValues[field.attributeName]:'')}
                content={formGroupValue}
                tagMode={field.tagMode}
              />
            );
          break;
          default:
            out = (
              <FormInputText
                id={`${configFile.attributeName}-${field.attributeName}`}
                key={field.attributeName + i}
                name={field.label}
                placeholder={field.placeholder}
                helpText={field.helpText}
                type={field.type}
                encrypt={field.encrypt}
                protect={field.protect}
                avoidAutofill={field.avoidAutofill?field.avoidAutofill:false}
                // value={(fieldValue?fieldValue[field.attributeName]:(value[field.attributeName]!= undefined?value[field.attributeName]:''))}
                value={(formGroupValue && formGroupValue[field.attributeName]?formGroupValue[field.attributeName]:defaultValues[field.attributeName]?defaultValues[field.attributeName]:'')}
                label={field.label}
                multiple={field.multiple}
                multiline={field.multiline}
                configFile={field.fromCatalog}
                onChange={(event) => handlerOnChange(event, field.attributeName)}
                validation={errorState[field.attributeName] === undefined
                  ? FormValidation.PENDING : FormValidation.ERROR}
                errorText={errorState[field.attributeName] === undefined
                  ? '' : errorState[field.attributeName][0]}
                // defaultValue={field.default === undefined ? '' : field.default}
                defaultValue={defaultValues && defaultValues[field.attributeName] === undefined ? '' : defaultValues[field.attributeName]}
                pattern={field.pattern}
                hidden={field.hidden}
                disabled={(field.disabled?field.disabled:false)}
                refreshData={(field.refreshData?field.refreshData:null)}
                importButton={field.importButton}
                configFileImport={field.configFileImport}
                fieldToImport={field.fieldToImport}
                min={(field.min?field.min:null)}
                max={(field.max?field.max:null)}
              />
            );
        }
        if(field.ifParentAttributName){
          if(field.ifParentAttributName.includes(configFile.attributeName))
            return (<div key={field.attributeName+i} className={field.className?field.className:"col-sm-12"}>{out}</div>);
          
        }else
          return (<div key={field.attributeName+i} className={field.className?field.className:"col-sm-12"}>{out}</div>);
      })}
      </div>
    </Accordion>}
    </>
  );
};

FormGroup.propTypes = {
  /**
   * Value store on redux to edit inside the form
   */
  value: PropTypes.shape({}),
  /**
   * Config file
   */
  configFile: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  onDeleteInputRelationship: PropTypes.func,
  onChangeItemPosition: PropTypes.func,
  onCreateWithRefresh: PropTypes.func,
  onUpload: PropTypes.func,
  onCompletedUploadFiles: PropTypes.func,
  onCanceledUploadFiles: PropTypes.func,
  popupOpenStatus:PropTypes.func,
};

FormGroup.defaultProps = {
  value: undefined,
  onChange: () => {},
  onReset: () => {},
  onDeleteInputRelationship: () => {},
  onCreateWithRefresh: () => {},
  onChangeItemPosition: () => {},
  onUpload: () => {},
  onCompletedUploadFiles: () => {},
  onCanceledUploadFiles: () => {},
  popupOpenStatus: () => {},
  initialValuesRef: null,
};

export default FormGroup;
